import { ContactFormTopicOption } from '../models/contact-form-data';

export const contactFormGroupIds = {
    b2b: 101000364039,
    dental: 101000364017,
    internationalHealth: 101000364065,
    electronics: 101000364066,
    tablet: 101000364067,
    music: 101000364068,
    accounting: 101000276897,
    contract: 101000364069,
    termination: 101000285540,
    other: 101000285541,
};

export const contactFormTopicOptions: ContactFormTopicOption[] = [
    {
        topic: 'insurance_electronics',
        label: 'Elektronik- oder Handyversicherung',
        groupId: contactFormGroupIds.electronics,
        type: 'Kontaktformular',
    },
    {
        topic: 'insurance_tablet',
        label: 'Tabletversicherung für die Schule',
        groupId: contactFormGroupIds.tablet,
        type: 'Kontaktformular',
    },
    {
        topic: 'accounting',
        label: 'Buchhaltung',
        groupId: contactFormGroupIds.accounting,
        type: 'Kontaktformular',
    },
    {
        topic: 'other',
        label: 'Sonstiges',
        groupId: contactFormGroupIds.other,
        type: 'Kontaktformular',
    },
];
